
import * as angular from "angular";
import * as moment from "moment";
import "./timeline.scss";

/* Usage
 *

<!--<timeline>
    <timeline-entry ng-repeat="entry in $ctrl.trailerEntries" entry="entry">
        <div class="text-muted font-size-11">{{entry.end | veriDate : 'date'}}</div>

        <veri-card class="m-0">
            <div class="reg-container" layout="row">
                <div class="vehicle-reg">{{entry.data.vehicle.ShortReg}}</div>

                <div class="vehicle-reg trailer">{{entry.data.trailer.ShortReg}}</div>
            </div>
        </veri-card>
    </timeline-entry>
</timeline>-->
 
 * */

interface IComponentController {
    entries: ITimelineEntry[];
}

export interface ITimelineEntry {
    current?: boolean;
    start: moment.Moment;
    end: moment.Moment;
    data: any;
}

class ComponentController implements angular.IComponentController, IComponentController {

    loading: boolean;

    entries: ITimelineEntry[] = [];

    static $inject = ["$element", "$transclude"];

    constructor(
        private readonly $element: angular.IAugmentedJQuery,
        private readonly $transclude: angular.ITranscludeFunction) {
    }

    $onInit() {
        this.$transclude((transEl, transScope: any) => {

            this.$element.empty();
            this.$element.append(transEl);
        });
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
    }
}

export class TimelineComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: boolean;

    constructor() {
        this.bindings = {
            entries: "<",
        };

        this.transclude = true;

        this.controller = ComponentController;
        this.template = require("./timeline.html");
    }
}
